import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { birthdayToAge } from '../utils/user';

function BirthdayField({ birthday, setAge, setBirthday, className }) {
  useEffect(() => {
    const a = birthdayToAge(birthday);
    setAge(a);
  }, [birthday]);

  return (
    <input
      type="date"
      name="birthday"
      required
      value={birthday}
      onChange={(e) => setBirthday(e.target.value)}
      className={classNames('form-control', className)}
    />
  );
}

BirthdayField.propTypes = {
  birthday: PropTypes.string.isRequired,
  setAge: PropTypes.func.isRequired,
  setBirthday: PropTypes.func.isRequired,
  className: PropTypes.string,
};

BirthdayField.defaultProps = {
  className: null,
};

export default BirthdayField;
